document.addEventListener("variant:add", function(event) {
  // Access the event details
  const items = event.detail.items;
  const cart = event.detail.cart;
  const products = items.map(item => ({
    content_name: item.title,
    content_ids: item.id,
    content_type: 'product',
    value: (item.price / 100).toFixed(2),
    currency: cart.currency
  }));
  
  fbq('track', 'AddToCart', {
    contents: products,
    currency: cart.currency
  });

});